import React from "react";
import { Link } from "gatsby";
import { slug } from "../utils/slug";
import { twMerge } from "tailwind-merge";

const Btn = ({ btnType, btnClr, btnText, btnLink }) => {
  const cls = `min-w-[187px] h-11 text-center flex items-center justify-center px-4 py-3 text-lg border border-solid rounded-[4px] block`;
  const solid = `${
    btnClr === "secondary"
      ? "bg-secondary text-[#313131] border-secondary hover:bg-transparent hover:text-secondary"
      : "bg-primary text-white border-primary hover:bg-transparent hover:text-primary hover:border hover:border-solid hover:border-primary"
  }`;
  const outline = `${
    btnClr === "secondary"
      ? "bg-transparent text-secondary border-secondary hover:bg-secondary/5"
      : "bg-transparent text-primary border-primary hover:bg-primary/5"
  }`;

  if (btnType === "outline") {
    return (
      <Link
        className={`transition-colors ease-linear duration-150 ${cls} ${outline}`}
        to={slug(btnLink)}
        aria-label={btnText}
      >
        {btnText}
      </Link>
    );
  }
  return (
    <Link
      className={`transition-colors ease-linear duration-150 ${cls} ${solid}`}
      to={slug(btnLink)}
      aria-label={btnText}
    >
      {btnText}
    </Link>
  );
};

export default Btn;

export const Btn2 = ({ data, cls = "" }) => {
  const className = `min-w-[167px] h-10 text-center flex items-center justify-center px-4 py-2 text-lg border border-solid font-bold rounded font-nunito`;
  const solid = `${
    data.buttonColor === "secondary"
      ? "bg-secondary-gradient border-secondary group"
      : "bg-primary-gradient border-primary hover:border hover:border-solid hover:border-primary group"
  }`;

  const text = `${
    data.buttonColor === "secondary"
      ? "text-white group-hover:text-secondary"
      : "text-white group-hover:text-primary"
  }`;
  const outline = `${
    data.buttonColor === "secondary"
      ? "bg-transparent text-secondary border-secondary hover:bg-secondary hover:text-white"
      : "bg-transparent text-primary border-primary hover:bg-primary hover:text-white"
  }`;

  const underline = `${
    data.buttonColor === "secondary"
      ? "bg-transparent text-secondary border-0 underline underline-offset-4"
      : "bg-transparent border-0 text-primary underline underline-offset-4"
  }`;

  if (data.buttonType === "outline") {
    if (data.linkType === "slug") {
      return (
        <Link
          className={twMerge(
            `transition-colors ease-linear duration-150 ${className} ${outline}`,
            cls
          )}
          to={slug(data.slug.current)}
          aria-label={data.buttonText}
        >
          {data.buttonText}
        </Link>
      );
    } else if (data.linkType === "url") {
      return (
        <a
          className={twMerge(
            `transition-colors ease-linear duration-150 ${className} ${outline}`,
            cls
          )}
          href={data.url}
          target="_blank"
          aria-label={data.buttonText}
        >
          {data.buttonText}
        </a>
      );
    } else if (data.linkType === "upload") {
      return (
        <a
          className={twMerge(
            `transition-colors ease-linear duration-150 ${className} ${outline}`,
            cls
          )}
          href={data.pdf.asset.url}
          target="_blank"
          aria-label={data.buttonText}
        >
          {data.buttonText}
        </a>
      );
    }
  } else if (data.buttonType === "none") {
    if (data.linkType === "slug") {
      return (
        <Link
          className={twMerge(
            `transition-colors ease-linear duration-150 ${className} ${underline}`,
            `${cls} min-w-20`
          )}
          to={slug(data.slug.current)}
          aria-label={data.buttonText}
        >
          {data.buttonText}
        </Link>
      );
    } else if (data.linkType === "url") {
      return (
        <a
          className={twMerge(
            `transition-colors ease-linear duration-150 ${className} ${underline}`,
            `${cls} min-w-20`
          )}
          href={data.url}
          target="_blank"
          aria-label={data.buttonText}
        >
          {data.buttonText}
        </a>
      );
    } else if (data.linkType === "upload") {
      return (
        <a
          className={twMerge(
            `transition-colors ease-linear duration-150 ${className} ${underline}`,
            `${cls} min-w-20`
          )}
          href={data.pdf.asset.url}
          target="_blank"
          aria-label={data.buttonText}
        >
          {data.buttonText}
        </a>
      );
    }
  } else {
    if (data.linkType === "slug") {
      return (
        <Link
          className={twMerge(
            `transition-colors ease-linear duration-150 ${className} ${solid}`,
            cls
          )}
          to={slug(data.slug.current)}
          aria-label={data.buttonText}
        >
          <span className={text}>{data.buttonText}</span>
        </Link>
      );
    } else if (data.linkType === "url") {
      return (
        <a
          className={twMerge(
            `transition-colors ease-linear duration-150 ${className} ${solid}`,
            cls
          )}
          href={data.url}
          target="_blank"
          aria-label={data.buttonText}
        >
          <span className={text}>{data.buttonText}</span>
        </a>
      );
    } else if (data.linkType === "upload") {
      return (
        <a
          className={twMerge(
            `transition-colors ease-linear duration-150 ${className} ${solid}`,
            cls
          )}
          href={data.pdf.asset.url}
          target="_blank"
          aria-label={data.buttonText}
        >
          <span className={text}>{data.buttonText}</span>
        </a>
      );
    }
  }
};
